import { getSingleHistory, pinThread, serverUrl, getThinkingLogs } from "../../data/dataApi";
import ContentWrapper from "../../views/components/ContentWrapper";
import { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import React from 'react';
import { Button, Offcanvas } from "react-bootstrap";

const DashboardSingleHistory = () => {
    const [chatHistory, setChatHistory] = useState([]);
    const [pinned, setPinned] = useState(false);
    const [sessionAccounts, setSessionAccounts] = useState([]);
    const [selectedChatId, setSelectedChatId] = useState(null);
    const [thinkingLogs, setThinkingLogs] = useState([]);

    const { sessionId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        (async () => {
            const response = await getSingleHistory(sessionId);

            if (response.success) {
                const { rows } = response.data;
                setChatHistory(rows);
                setPinned(rows[0].pinned);

                const accounts = rows.filter(row => row.account !== null).map(row => JSON.parse(row.account));
                setSessionAccounts(new Set(accounts));
            }

            // Fetch thinking logs
            const thinkingData = await getThinkingLogs(sessionId);
            if (thinkingData.success) {
                setThinkingLogs(thinkingData.data.rows || []);
            }
        })();
    }, [sessionId]);

    const handlePinThread = async () => {
        const response = await pinThread(sessionId);

        if (response.success) {
            setPinned(response.data.pinned);
        }
    };

    return (
        <>
            <ContentWrapper className="scrollable">
                <div className="back-wrapper">
                    <button className="dashboard-tertiary-btn tif-mb-10"
                        onClick={() => {
                            if (location.key === 'default') {
                                navigate('/dashboard/history')
                            } else {
                                navigate(-1)
                            }
                        }}>
                        Back
                    </button>
                </div>
                <div className="wrapper tif-bg-color-tertiary tif-bg-light-color-white">
                    <div className="d-flex justify-content-between tif-mb-20">
                        <Button className={`tertiary-btn tif-mb-10 ${pinned ? 'filled' : ''}`} onClick={handlePinThread}><img src={`${serverUrl}/static/assets/${pinned ? 'pin-filled' : 'pin'}.svg`} alt="Pin icon" /> {pinned ? "Pinned" : "Pin"}</Button>
                    </div>

                    {
                        sessionAccounts.size ?
                            <div className="tif-mb-30">
                                <h2 className="tif-h3">Account Details</h2>
                                {
                                    Array.from(sessionAccounts).map((account, index) => (
                                        <ul key={index}>
                                            <li>
                                                <span className="bold">Deacom ID:</span> {account.deacom_id || "Undefined"}
                                            </li>
                                            <li>
                                                <span className="bold">Wordpress ID:</span> {account.wordpress_id}
                                            </li>
                                            <li>
                                                <span className="bold">Email:</span> {account.email}
                                            </li>
                                        </ul>
                                    ))
                                }
                            </div>
                            :
                            <></>
                    }
                    <div className="table-wrapper">
                        <table className="secondary-table w-100">
                            <thead>
                                <tr>
                                    <td>Sender</td>
                                    <td>Message</td>
                                    <td style={{ width: "20%" }}>User Email</td>
                                    <td style={{ width: "20%" }}>Origin URL</td>
                                    <td style={{ width: "15%" }}>Bot Type</td>
                                </tr>
                            </thead>

                            {chatHistory.map((history, index) => (
                                <React.Fragment key={index}>
                                    <tbody>
                                        <tr className="spacer-row" key={`${index}-0`}>
                                            <td colSpan="3"></td>
                                        </tr>
                                    </tbody>
                                    <tbody className="secondary-body">
                                        <tr className="first-row" key={`${index}-1`}>
                                            <td>User</td>
                                            <td>{history.user_message}</td>
                                            <td>{history.user_email}</td>
                                            <td><a className="link-out" href={history.origin} target="_blank">{history.origin}</a></td>
                                            <td>{history.bot_type}</td>
                                        </tr>
                                        <tr className="second-row" key={`${index}-2`}>
                                            <td>Chatbot</td>
                                            <td dangerouslySetInnerHTML={{ __html: history.api_response }}></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                {thinkingLogs.filter(log => log.chat_id === history.id).length > 0 && (
                                                    <Button 
                                                        className="tertiary-btn filled" 
                                                        size="sm"
                                                        onClick={() => setSelectedChatId(history.id)}
                                                    >
                                                        <img src={`${serverUrl}/static/assets/message.svg`} className="tif-mr-5" alt="Message icon" />
                                                        Thinking Logs
                                                    </Button>
                                                )}
                                            </td>
                                        </tr>
                                    </tbody>

                                </React.Fragment>
                            ))}
                        </table>
                    </div>
                </div>
            </ContentWrapper>
            <Offcanvas show={selectedChatId !== null} onHide={() => setSelectedChatId(null)} placement="end" className="thinking-messages-offcanvas tif-bg-color-tertiary tif-color-white">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Thinking Logs</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {selectedChatId && (
                        <ul className="list-unstyled">
                            {thinkingLogs
                                .filter(log => log.chat_id === selectedChatId)
                                .map((log, index) => (
                                    <li key={log.id || index} className="tif-font-sm tif-mb-15 tif-pb-15">
                                        {log.log}
                                    </li>
                                ))}
                        </ul>
                    )}
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}

export default DashboardSingleHistory;